import React from 'react';
import './App.css';
import Form from './components/form/Form';


export default function App() {
  return <Form />;
}
